import { combineReducers, type UnknownAction } from '@reduxjs/toolkit';

import { replaceVehicleValue } from 'Core/actions/fitmentSearch/index';
import { createIsolatedReducer } from 'Core/reducers/common';

import { fitmentFieldsReducer, fitmentResponseReducer, fixRequestDueToResponse } from './common';
import isolatedDialog from './isolatedDialog/index';
import isolatedHeader from './isolatedHeader/index';
import isolatedKey from './isolatedKey';
import request from './request';
import smallReducers from './smallReducers';
import storage from './storage';
import verifyFitment from './verifyFitment';

const baseFitmentSearch = combineReducers({
  request: createIsolatedReducer(isolatedKey, request),
  response: createIsolatedReducer(isolatedKey, fitmentResponseReducer),
  fields: createIsolatedReducer(isolatedKey, fitmentFieldsReducer),
  storage,
  isolatedDialog,
  isolatedHeader,
  verifyFitment,
  ...smallReducers,
});

type FitmentSearchState = ReturnType<typeof baseFitmentSearch>;

const fitmentSearch = (state: FitmentSearchState | undefined, action: UnknownAction): FitmentSearchState =>
  baseFitmentSearch(fixRequestDueToResponse(state, replaceVehicleValue.match(action)), action);

export default fitmentSearch;
